'use client';
/**
 * В случае Яндекс-метрики нам предоставлена возможность определять, готов ли
 * счётчик к работе с помощью специального JavaScript события.
 *
 * https://yandex.ru/support/metrica/code/counter-initialize.html#counter-initialize__check-initialize
 * */ const isScriptLoaded = (counterId)=>()=>{
        const eventType = `yacounter${counterId}inited`;
        return new Promise((resolve)=>{
            function listener() {
                resolve(true);
            }
            document.addEventListener(eventType, listener, {
                once: true
            });
        });
    };

export { isScriptLoaded };
//# sourceMappingURL=status.js.map
